import { useMemo } from 'react'
import { useExceptions } from '../../api/exceptions'
import { usePayouts } from '../../api/payouts'
import { openFailures, type FailureItem } from '../../model/payoutBoard'

/**
 * Open failures (F4-B4.a): the failed and returned tries joined with the open PAYMENT_FAILED
 * exceptions (when they are readable). Up to 100 of each status — enough for a day's office work.
 */
export function useOpenFailures(): { items: FailureItem[]; isLoading: boolean; error: unknown } {
  const failed = usePayouts({ status: 'FAILED', page: 1, limit: 100 })
  const reversed = usePayouts({ status: 'REVERSED', page: 1, limit: 100 })
  const ex = useExceptions({ type: 'PAYMENT_FAILED', status: 'OPEN', page: 1, limit: 200 })
  const items = useMemo(
    () => openFailures([...(failed.data?.rows ?? []), ...(reversed.data?.rows ?? [])], ex.isError ? null : (ex.data?.rows ?? [])),
    [failed.data, reversed.data, ex.data, ex.isError],
  )
  return {
    items,
    isLoading: failed.isLoading || reversed.isLoading || ex.isLoading,
    error: failed.error ?? reversed.error ?? null,
  }
}
